import React from "react";

import RegistrationLayout from "./components/RegistrationLayout";
import { connect } from "react-redux";

import { Creators as DataCreators } from "../data/reducer";
import {
  Creators as RegistrationCreators,
  getCurrentRegistration
} from "./reducer";
import { Redirect } from "react-router-dom";

import * as firebase from 'firebase';

const withRegistrationBehavior = WrappedComponent =>
  class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        listenerRef: null
      };

      this.loadRegistration = this.loadRegistration.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
      // In the event of a refresh, we may not have the current registration
      // loaded but will have the id in local storage.
      const { currentRegistrationId, currentRegistration } = this.props;

      if (currentRegistrationId && !currentRegistration) {
        this.loadRegistration(currentRegistrationId);
      }
    }

    componentWillReceiveProps(nextProps) {
      const { currentRegistrationId } = this.props;
      const newRegistrationId = nextProps.currentRegistrationId;

      // If we have a new registration id, then we need to disconnect and load
      // the new one.
      if (currentRegistrationId !== newRegistrationId) {
        if (this.state.listenerRef) {
          this.state.listenerRef.off();
        }

        if (newRegistrationId) {
          this.loadRegistration(newRegistrationId);
        }
      }
    }

    loadRegistration(registrationId) {
      const path = `registrations/${registrationId}`;
      const listenerRef = firebase
        .database()
        .ref(`registrations/${registrationId}`);

      listenerRef.on("value", snapshot =>
        this.props.onDataReceived(path, snapshot.val())
      );

      this.setState({
        listenerRef
      });
    }

    handleCancel() {
      const { history, cancelRegistration } = this.props;

      cancelRegistration();
      history.push("/registration/start");
    }

    render() {
      const { step } = this.props.match.params;
      const { currentRegistration } = this.props;

      // Default path if a user hits /registration
      if (!step && !currentRegistration) {
        return <Redirect to={"/registration/start"} push />;
      }

      // Wait for current registration to load before proceeding
      if (step && !currentRegistration && step !== "start") {
        return <div>Loading</div>;
      }

      // The server can "push" a user to another step by setting the
      // the step attribute on the registration. This will sync back to the
      // client as currentRegistration.
      //
      // We tell if this happens by the currentRegistration.step property
      // being different than the route param.
      if (
        currentRegistration &&
        currentRegistration.step &&
        currentRegistration.step !== step
      ) {
        return (
          <Redirect to={`/registration/${currentRegistration.step}`} push />
        );
      }

      return <WrappedComponent {...this.props} onCancel={this.handleCancel} />;
    }
  };

export default connect(
  state => ({
    location: state.data.locations[state.login.location],
    currentRegistrationId: state.registration.currentRegistrationId,
    currentRegistration: getCurrentRegistration(state)
  }),
  (dispatch, ownProps) => ({
    cancelRegistration: () =>
      dispatch(
        RegistrationCreators.cancelRegistration(ownProps.currentRegistrationId)
      ),
    onDataReceived: (path, data) =>
      dispatch(DataCreators.dataReceived(path, data))
  })
)(withRegistrationBehavior(RegistrationLayout));



// WEBPACK FOOTER //
// ./src/registration/index.js